import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DocumentCard, DocumentCardDetails, FontSizes, HoverCard, HoverCardType, IconButton, } from '@fluentui/react';
import { useThemeData, setColorAlpha } from '@msrceng/theme';
/**
 * Help-text icon that renders an icon with a popout tooltip
 *
 * @constant
 */
export const IconTooltip = ({ content, iconName = 'Info', ariaLabel, role = 'tooltip', }) => {
    var _a;
    const { theme } = useThemeData();
    // const id = getId('icon-tooltip');
    return (_jsxs(HoverCard, Object.assign({ styles: { host: { display: 'inline-block' } }, type: HoverCardType.plain, plainCardProps: {
            styles: {
                root: {
                    color: (_a = theme === null || theme === void 0 ? void 0 : theme.semanticColors) === null || _a === void 0 ? void 0 : _a.bodyText,
                    background: 'transparent',
                },
            },
            onRenderPlainCard: () => (_jsx(DocumentCard, { children: _jsx(DocumentCardDetails, Object.assign({ styles: { root: { padding: '1em' } } }, { children: _jsx("button", Object.assign({ role: 'menuitem', style: {
                            background: 'none',
                            color: 'inherit',
                            border: 'none',
                            padding: 0,
                            font: 'inherit',
                            cursor: 'pointer',
                            outline: 'inherit',
                            textAlign: 'inherit',
                            textDecoration: 'none',
                        } }, { children: content })) })) })),
        }, setInitialFocus: true, instantOpenOnClick: true, trapFocus: true }, { children: [_jsx(IconButton, { styles: {
                    root: {
                        //remove padding so the icon is a little closer
                        padding: '0',
                        //make the button slightly wider than the base area for big fingers
                        margin: '0 -0.3em',
                        background: 'transparent',
                        display: 'inline-block',
                    },
                    rootHovered: {
                        background: setColorAlpha((theme === null || theme === void 0 ? void 0 : theme.semanticColors.buttonBackground) || '#fff', 0.07),
                    },
                }, iconProps: {
                    iconName,
                    styles: {
                        root: {
                            fontSize: FontSizes.small,
                        },
                    },
                }, "aria-label": ariaLabel || 'Help text', "aria-haspopup": 'true', role: role || 'tooltip' }), ' '] })));
};
